const LoadingWrapperFactory = (props: React.HTMLProps<HTMLDivElement>): React.FC => ({
    children
}) => <div {...props}>{children}</div>;

export default LoadingWrapperFactory;
